<template>
  <b-container v-if="!user.farmacia_preferita">
    <h5 class="p-4">
      Scegli una farmacia nel tuo
      <span class="text-prim-grad-1">Circolo di Cura</span> e contrassegnala
      come "Preferita" per accedere al tuo Profilo Sanitario.
    </h5>
    <b-row class="justify-content-center">
      <b-button
        @click="$router.push({ name: 'circolo di cura' })"
        variant="primary fw-bolder "
        >Vai al Circolo di Cura</b-button
      >
    </b-row>
  </b-container>
  <b-container v-else>
    <template v-if="!user.profilo_sanitario_pp">
      <AccettaInformativaProfiloSanitario
        @consense-updated="$nextTick(() => me())"
      ></AccettaInformativaProfiloSanitario>
    </template>
    <template v-else>
      <b-row cols="1" class="text-left mb-3">
        <router-link
          class="fw-bolder text-primary no__hover"
          :to="{ name: 'CittadinoHome' }"
        >
          <b-icon icon="arrow-left-circle-fill" variant="primary"></b-icon>
          Homepage</router-link
        >
      </b-row>
      <b-row class="col-12 justify-content-center">
        <b-button-group class="mb-3 bg-line-grey rounded-pill flex-wrap">
          <b-button
            class="fw-bolder text-capitalize"
            :size="$root.isMobile ? 'sm' : ''"
            @click="activePanel = 'rilevazioni'"
            :variant="
              activePanel === 'rilevazioni'
                ? 'primary primary_gradient text-white rounded-pill'
                : 'bg-light text-primary'
            "
            >rilevazioni</b-button
          >
          <b-button
            class="fw-bolder text-capitalize"
            :size="$root.isMobile ? 'sm' : ''"
            @click="activePanel = 'patologie'"
            :variant="
              activePanel === 'patologie'
                ? 'primary primary_gradient text-white rounded-pill'
                : 'bg-light text-primary'
            "
            >patologie</b-button
          >
          <b-button
            class="fw-bolder text-capitalize"
            :size="$root.isMobile ? 'sm' : ''"
            @click="activePanel = 'therapies'"
            :variant="
              activePanel === 'therapies'
                ? 'primary primary_gradient text-white rounded-pill'
                : 'bg-light text-primary'
            "
            >armadietto</b-button
          >
          <b-button
            class="fw-bolder text-capitalize"
            :size="$root.isMobile ? 'sm' : ''"
            @click="activePanel = 'pic_plan'"
            :variant="
              activePanel === 'pic_plan'
                ? 'primary primary_gradient text-white rounded-pill'
                : 'bg-light text-primary'
            "
            >piani terapeutici</b-button
          >
          <b-button
            class="fw-bolder text-capitalize"
            :size="$root.isMobile ? 'sm' : ''"
            @click="activePanel = 'note'"
            :variant="
              activePanel === 'note'
                ? 'primary primary_gradient text-white rounded-pill'
                : 'bg-light text-primary'
            "
            >note</b-button
          >
        </b-button-group>
      </b-row>
      <transition-group name="list" mode="out-in" appear>
        <b-row v-if="activePanel === 'rilevazioni'" key="rilevazioni">
          <RilevazioniComponent :block-add="blockDataAdd" :subject="subject" />
        </b-row>
        <b-row v-if="activePanel === 'patologie'" key="patologie">
          <h6
            class="text-prim-grad-1 fw-bolder text-left pb-1 border-bottom border-line-grey ml-3 mt-3"
          >
            Patologie
          </h6>
          <PatologieComponent :block-add="blockDataAdd" :subject="subject" />
        </b-row>
        <b-row v-if="activePanel === 'therapies'" key="therapies">
          <ArmadiettoComponent :block-add="blockDataAdd" :subject="subject" />
        </b-row>
        <b-row v-if="activePanel === 'pic_plan'" key="pic_plan">
          <PianiTerapeutici />
        </b-row>
        <b-row v-if="activePanel === 'note'" key="note">
          <PatientAnnotations
            :subjectHash="subject && subject.hashid"
            :hidetop="false"
          />
        </b-row>
      </transition-group>
    </template>
  </b-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import RilevazioniComponent from "@/components/profile/sanitario/RilevazioniComponent.vue";
import PatologieComponent from "@/components/profile/sanitario/PatologieComponent.vue";
import ArmadiettoComponent from "@/components/profile/sanitario/ArmadiettoComponent.vue";
import PatientAnnotations from "@/components/pazienti/note/PatientAnnotations.vue";
import AccettaInformativaProfiloSanitario from "@/components/profile/AccettaInformativaProfiloSanitario.vue";
import PianiTerapeutici from "@/components/clienti/PianiTerapeutici.vue";
export default {
  name: "ProfiloSanitario",
  components: {
    RilevazioniComponent,
    PatologieComponent,
    ArmadiettoComponent,
    PianiTerapeutici,
    PatientAnnotations,
    AccettaInformativaProfiloSanitario,
  },
  data() {
    return {
      activePanel: "rilevazioni",
      subject: null,
      panels: ["rilevazioni", "patologie", "therapies", "pic_plan"],
    };
  },
  // watch: {
  //   user: {
  //     handler(val) {},
  //     deep: true,
  //   },
  // },
  computed: {
    blockDataAdd() {
      // if (this.user) {
      //   return this.user.my_circle.length < 1;
      // }
      return false;
    },
    blockView() {
      if (this.user) {
        return this.user.farmacia_preferita == null;
      }
      return true;
    },
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    ...mapActions("utente", ["me"]),
    fetchUser() {
      // get user by id, then subjectId = user fetched hashid
      // subject:{
      //   hashid:user.hashid,
      //   type:"familiare"
      // }
    },
  },
  created() {
    if (this.$route.params.subject) {
      this.fetchUser();
    }
    if (
      this.$route.query.scope &&
      this.panels.includes(this.$route.query.scope)
    ) {
      this.activePanel = this.$route.query.scope;
    }
  },
};
</script>
